
import { Card, Text, Divider, Switch, Avatar, Button} from "@fluentui/react-components";
import { useContext, useState } from "react";
import WelcomeCardSkeleton from "./welcome-card-skeleton";
import { useEffect } from 'react';
import { StateContext } from "../../../core/store/state-context";
import { APIInterceptor } from "../../../core/interceptor/api-interceptor";
import APIHelper from "../../../services/api-helper";
import { LogError, RandomGlowImage } from "../../../utility/app-utilities";
import { errorLoggingConstants, _blank } from "../../../utility/app-constants";
import { componentConstants, welcomeCardGlowImagesConstants } from "../../../utility/app-constants";
import { Open16Regular } from "@fluentui/react-icons";
import BadgeWrapper from "./welcome-card-badge-wrapper";
import { accountSummaryConstants } from "../../../utility/app-constants";
import AccountSummaryErrorScreen from "../error-screens/account-summary-error-screen";

/**
 * To Display welcome card
 * @returns 
 */
export default function WelcomeCard() {
    const [accountSummaryToggle, setAccountSummaryToggle] = useState(false);
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(true);
    const [{ context }] = useContext(StateContext);
    const [userFullName, setUserFullName] = useState<string>();
    const [userPhoto, setUserPhoto] = useState<string>();
    const [axios] = APIInterceptor("welcome component");
    const [glowImage] = useState(RandomGlowImage(welcomeCardGlowImagesConstants.glowImage as []));
    const apiHelper = new APIHelper(axios, context);
    const [accountSummaryJsonData, setAccountSummaryJsonData] = useState([]);
    const [userDetailsAPIFailed, setUserDetailsAPIFailed] = useState<boolean>();
    const [accountSummaryAPIFailed, setAccountSummaryAPIFailed] = useState<boolean>();

    /**
     *  accountSummaryHTML function returns JSX element based on top 3 account summary APi data
     * @param accountSummaryDataArray
     * @param flag is true when toggle is on and false when toggle is off
     * @returns top three jsx elements for account Summary
     */
    function accountSummaryHTML(accountSummaryDataArray: any, flag: boolean) {
        const accountSummaryData = accountSummaryDataArray;
        let accountSummaryJSX: JSX.Element | null = null
        let accountSummaryDisplayJSX: JSX.Element[] = [];
        let columnNumber: number = 0;
        accountSummaryData.forEach((element: any) => {
            columnNumber += 1
            if (element.subType === accountSummaryConstants.hsa) {
                accountSummaryJSX =
                    <div className={`account-summary-col-${columnNumber}`} key={element.subType}>
                        {flag ?
                            <><Text weight="bold" className="account-summary-hsa-heading">{element.title}</Text>
                                <div className='account-summary-col-1-content-wrap'>
                                    <div className='available-bal'>
                                        <Text size={200} className="account-summary-gray-color">{element.planDetails.headerAvailable}</Text>
                                        <Text className="account-summary-amount" >{element.planDetails.availableAmount}</Text>
                                    </div>
                                    <div className='available-bal'>
                                        <Text size={200} className="account-summary-gray-color">{element.planDetails.headerInvestment}</Text>
                                        <Text className="account-summary-amount" >{element.planDetails.investmentAmount}</Text>
                                    </div>
                                </div>
                            </> :
                            <><Text weight="bold">{element.title}</Text>
                                <BadgeWrapper numOfBadges={7} />
                            </>
                        }
                    </div>
                accountSummaryDisplayJSX?.push(accountSummaryJSX);
            }
            else if (element.subType === accountSummaryConstants.medical) {
                accountSummaryJSX =
                    <div className={`account-summary-col-${columnNumber}`} key={element.subType}>
                        {flag ?
                            <><Text className="account-summary-top-heading" weight="bold">{element.title}</Text>
                                <Text className="account-summary-medical-plan" size={400} weight="semibold">{element.planDetails.plan}</Text>
                                <Text className="account-summary-gray-color" size={200}>{element.planDetails.coverage}</Text>
                            </> :
                            <><Text weight="bold">{element.title}</Text>
                                <BadgeWrapper numOfBadges={7} />
                            </>
                        }
                    </div>
                accountSummaryDisplayJSX?.push(accountSummaryJSX);
            }
            else if (element.subType === accountSummaryConstants.pension) {
                accountSummaryJSX =
                    <div className={`account-summary-col-${columnNumber}`} key={element.subType}>
                        {flag ?
                            <><Text className="account-summary-top-heading" weight="bold">{element.title}</Text>
                                <Text className="account-summary-gray-color">{element.planDetails.planType}</Text>
                                <Text className="account-summary-amount-pension">{element.planDetails.benefit}</Text>
                                <Text className="account-summary-gray-color">{element.planDetails.footer}</Text>

                            </> :
                            <><Text weight="bold">{element.title}</Text>
                                <BadgeWrapper numOfBadges={7} />
                            </>}
                    </div>
                accountSummaryDisplayJSX?.push(accountSummaryJSX);
            }
            else if (element.subType === accountSummaryConstants.plan401k) {
                accountSummaryJSX =
                    <div className={`account-summary-col-${columnNumber}`} key={element.subType}>
                        {flag ?
                            <> <Text className="account-summary-top-heading" weight="bold">{element.title}</Text>
                                <Text className="account-summary-gray-color">{element.planDetails.planDescription}</Text>
                                <Text className="account-summary-amount">{element.planDetails.balance}</Text>
                                <Text className="account-summary-gray-color" size={200}>{element.planDetails.footer}</Text>
                            </> :
                            <><Text weight="bold">{element.title}</Text>
                                <BadgeWrapper numOfBadges={7} />
                            </>
                        }
                    </div>
                accountSummaryDisplayJSX?.push(accountSummaryJSX);
            }
        });

        return (
            <>
                {accountSummaryDisplayJSX}
            </>
        )
    }
    /* showSensitiveInfo will show/hide the account summary as toggle is turned ON/OFF */
    const showSensitiveInfo = () => {
        setAccountSummaryToggle(!accountSummaryToggle)
        setChecked(!checked)
    }

    /* Get user details and photo */
    useEffect(() => {
        GetUserDetails();
        GetUserPhoto();
        GetAccountSummary();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    /**
     * Get User Details from  ChannelAPI
     * @param userEmail - user email id
     */
    const GetUserDetails = () => {
        apiHelper.getUserDetails(context?.user?.userPrincipalName)
            .then(async (response) => {
                setUserFullName(response.data.givenName + " " + response.data.surName);
                setLoading(false);
            })
            .catch((error) => {
                setUserDetailsAPIFailed(true);
                const errorObject = {
                    component: errorLoggingConstants.welcomeComponentFile,
                    method: errorLoggingConstants.useEffect,
                    message: error as string,
                    operation: errorLoggingConstants.userDetailsAPI,
                    params: {}
                };
                LogError(errorObject);
            });
    }

    /**
     * Get User Photo from Channel API
     * @param userEmail - user email id
     */
    const GetUserPhoto = () => {
        apiHelper.getUserPhoto(context?.user?.userPrincipalName)
            .then(async (response) => {
                const url = window.URL || window.webkitURL;
                const userPhoto = url.createObjectURL(response.data);
                setUserPhoto(userPhoto);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false)
                const errorObject = {
                    component: errorLoggingConstants.welcomeComponentFile,
                    method: errorLoggingConstants.useEffect,
                    message: error as string,
                    operation: errorLoggingConstants.userPhotosAPI,
                    params: {}
                };
                LogError(errorObject);
            });
    }

    /**
     * Get account summary data from account Summary API
     */
    const GetAccountSummary = () => {
        apiHelper
            .getAccountSummary()
            .then(async (response) => {
                const accountSummaryJsonData = response.data;
                setAccountSummaryJsonData(accountSummaryJsonData)
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                setAccountSummaryAPIFailed(true);
                const errorObject = {
                    component: errorLoggingConstants.welcomeComponentFile,
                    method: errorLoggingConstants.useEffect,
                    message: error as string,
                    operation: errorLoggingConstants.personAccountSummaryAPI,
                    params: {}
                };
                LogError(errorObject);
            })
    }

    /**
     * Convert accountSummaryJsonData array
     */
    const accountSummaryJsonDataArray = accountSummaryJsonData.slice(0, 3).reverse();


    return (<>
        <Card className={!loading ? "welcome-card" : "welcome-card skeleton-bg"}>
            <img className={!loading ? "welcome-card-glow-img" : "welcome-card-skeleton-no-glow"} src={glowImage} alt="glow" />
            {!loading ? (
                <div className={userDetailsAPIFailed ? "welcome-card-content-wrapper error-screen" : "welcome-card-content-wrapper"}>
                    <div className="personalized-details">
                        <div className="user-details-wrap">
                            <Avatar name={userFullName} size={72} image={{ src: userPhoto }} />
                            <div className="user-name-profession-details">
                                <Text size={400}>{accountSummaryConstants.greet}</Text>
                                {
                                    userDetailsAPIFailed ?
                                        <Text style={{ fontSize: "32px" }} className="firstname-error-text" align="center" weight='semibold' size={800}>{componentConstants.missingUsernameError}</Text> :
                                        <Text className="user-name" align="center" weight='semibold' size={800}>{userFullName}</Text>
                                }
                            </div>
                        </div>
                    </div>
                    <Divider vertical appearance="strong" className="welcome-card-divider" />
                    <div className="account-summary">
                        <div className="account-summary-title-wrap" data-testid="acc-summary-title-wrap">

                            {accountSummaryJsonDataArray.length || accountSummaryAPIFailed ? <><Text weight="bold" className="account-summary-heading">{componentConstants.accountSummary}</Text>
                                <Switch checked={checked} label={checked ? 'Hide Sensitive Information' : 'Show Sensitive Information'} labelPosition='before' onChange={showSensitiveInfo} data-testid="toggle-btn" /> </> : null}
                        </div>
                        <div className="account-summary-content-wrap">
                            {accountSummaryToggle ? (
                                <>
                                    {accountSummaryAPIFailed ? <AccountSummaryErrorScreen /> : accountSummaryJsonDataArray.length ? accountSummaryHTML(accountSummaryJsonDataArray.slice(0, 3).reverse(), true) : null}
                                </>
                            ) : (
                                <div className="currency-wrapper">
                                    {accountSummaryAPIFailed ? <AccountSummaryErrorScreen /> : accountSummaryJsonDataArray.length ? accountSummaryHTML(accountSummaryJsonDataArray.slice(0, 3).reverse(), false) : null}
                                </div>
                            )}
                        </div>
                        <div className="welcome-card-footer">
                            <Button data-testid="welcome-card-footer-button" appearance="outline" icon={<Open16Regular />} onClick={() => window.open(componentConstants.linkHrefUrl, _blank)}>
                                {componentConstants.viewMoreAtAlightWorklife}
                            </Button>
                        </div>
                    </div>
                </div>
            ) : (<WelcomeCardSkeleton />)}
        </Card>
    </>
    )
}
